import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .GGGRidWrapper': {
    position: 'relative',
    '& .GGGRid': {
      height: theme.spacing(81.75),
      '& > div': { height: '100%' },
      [theme.breakpoints.down('xl')]: {
        height: theme.spacing(62.5),
      },
      [theme.breakpoints.down('lg')]: {
        height: theme.spacing(44.125),
      },
    },
    '& .GGGRidShowTabletAndDesktop': {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
      },
    },
    '& .GGShowAll': {
      position: 'absolute',
      right: theme.spacing(3),
      bottom: theme.spacing(3),
      [theme.breakpoints.down('lg')]: {
        right: theme.spacing(1.5),
        bottom: theme.spacing(1.5),
      },
    },
  },
}));

export default StyledBox;
